// extracted by mini-css-extract-plugin
export default {"header":"contract-works_header__8ciaV","table":"contract-works_table__PGuMI","th1":"contract-works_th1__qtOVo"};